import '../banners.less';
import './index.less';

import { Col, Row } from 'antd';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

import BGImage from '../../../images/banners/session-in-numbers.jpg';
import BGImageMobile from '../../../images/banners/workout-in-numbers-mobile.jpg';
import Breakpoint from '../../../utils/breakpoint';
import CounterUSP from '../../BannerShared/CounterUSP';
import Title from '../../BannerShared/Title';

class TheWorkoutInNumbers extends Component {
  state = {
    sessionCountExact: 0,
    sessionCount: 0,
  };

  componentDidMount() {
    this.getCheckInsCount();
  }

  getCheckInsCount = async () => {
    const countExact = 200103;

    const countRounded = (Math.floor(countExact / 10000) * 10000) / 1000;
    this.setState({
      sessionCountExact: numeral(countExact).format('0,0'),
      sessionCount: countRounded,
    });
  };

  render() {
    return (
      <div
        className="banner banner-the-workout-in-numbers"
        style={{
          backgroundImage: `url(${BGImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
        }}
      >
        <div className="container">
          <Breakpoint max="sm">
            <img src={BGImageMobile} alt="The Workout In Numbers" />
          </Breakpoint>
          <Fade>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <section>
                  <Breakpoint max="sm">
                    <Row justify="center" gutter={0} style={{ marginTop: '-50px' }}>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <Title title="The Workout" isTagline isCenter />
                        <Title title="RITUAL数字" style={{ marginBottom: '50px' }} />
                      </Col>
                    </Row>
                  </Breakpoint>
                  <Row justify="space-between" gutter={20}>
                    <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                      <CounterUSP
                        value={30}
                        title="分钟高效训练"
                        body="由于余热效应，RITUAL HIIT的30分钟的训练就能提高你的新陈代谢率（即燃烧脂肪），时间长达48小时。"
                      />
                    </Col>

                    <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                      <CounterUSP
                        value="1-10"
                        title="人小班课程"
                        body="RITUAL HIIT的小班规模意味着您可以获得如同1对1一般的私教体验，也可以达到团体课的激励效果。"
                      />
                    </Col>
                  </Row>

                  <Breakpoint min="sm">
                    <div className="banner-the-workout-in-numbers_title">
                      <Row justify="center" gutter={0}>
                        <Col xs={24} sm={24} md={16} lg={12}>
                          <Title title="The Workout" isTagline isCenter />
                          <Title title="RITUAL数字" style={{ marginBottom: '50px' }} />
                        </Col>
                      </Row>
                    </div>
                  </Breakpoint>

                  <Row justify="space-between" gutter={20}>
                    <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                      <Breakpoint min="lg">
                        <CounterUSP
                          value={4}
                          title="种课程等级"
                          body="健身不是一刀切，RITUAL HIIT设定4种等级课程，依据客人自身情况及目标建立更适配的运动计划"
                        />
                      </Breakpoint>
                      <Breakpoint min="md" max="lg">
                        <CounterUSP
                          value={4}
                          title="种课程等级"
                          body="健身不是一刀切，RITUAL HIIT设定4种等级课程，依据客人自身情况及目标建立更适配的运动计划"
                        />
                      </Breakpoint>
                      <Breakpoint max="md">
                        <CounterUSP
                          value={4}
                          title="种课程等级"
                          body="健身不是一刀切，RITUAL HIIT设定4种等级课程，依据客人自身情况及目标建立更适配的运动计划"
                        />
                      </Breakpoint>
                    </Col>

                    <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                      <CounterUSP
                        value={0}
                        title="遗憾"
                        body="我们曾做过调查，这是体验者后悔体验RITUAL HIIT的实际次数"
                      />
                    </Col>
                  </Row>
                </section>
              </Col>
            </Row>
          </Fade>
        </div>
      </div>
    );
  }
}

TheWorkoutInNumbers.propTypes = {
  t: PropTypes.func,
};

export default TheWorkoutInNumbers;
